export default function reduceArrayToIdentityMap<T extends {id: string}>(array: Array<T>): Record<string, T> {
  return array.reduce((record, item) => {
    return {
      ...record,
      [item.id]: item
    }
  }, {} as Record<string, T>)
}